import { Step } from 'react-joyride';

const getWorkersTourSteps = (isMobile: boolean): Step[] => {
  const suffix = isMobile ? '-mobile' : '-desktop';

  const allSteps: (Step & { desktopOnly?: boolean })[] = [
    {
      target: '.tour-title',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Bienvenido a la sección de <strong>Trabajadores</strong>. Aquí
          gestionas todo el personal de tu empresa, lo vinculas con los
          servicios que realiza y controlas su disponibilidad. Mantener esta
          lista actualizada es clave para que las reservas se asignen
          correctamente.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-add-btn',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Usa este botón para <strong>añadir un nuevo trabajador</strong>. Se
          abrirá un formulario donde introduces su nombre, email, intervalo
          entre citas y los servicios que puede realizar. Si esa persona ya
          tiene cuenta en Bookoll, se vinculará automáticamente a tu empresa.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: '.tour-filter-input',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Este campo sirve para <strong>buscar trabajadores</strong> por nombre
          o correo electrónico. Ideal cuando tienes una plantilla grande y
          necesitas localizar a alguien rápido.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-table-head',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Esta es la <strong>lista de trabajadores</strong>. De un vistazo ves
          su foto, nombre, correo, el intervalo entre citas y su estado. Las
          columnas se actualizan automáticamente cuando editas a alguien.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
      desktopOnly: true,
    },
    {
      target: '.tour-confirmado-badge',
      content: (
        <div style={{ textAlign: 'justify' }}>
          <strong>Confirmado</strong> indica si el trabajador ya ha aceptado su
          invitación y activado su cuenta.
          <br />
          <br />
          <span style={{ color: '#10B981', fontWeight: 'bold' }}>✔ Sí</span>{' '}
          — ya tiene acceso a su panel y puede recibir citas.
          <br />
          <span style={{ color: '#EF4444', fontWeight: 'bold' }}>✘ No</span>{' '}
          — todavía no ha aceptado la invitación. Puedes reenviársela con el
          botón del avión de papel.
        </div>
      ),
      placement: 'right',
      disableBeacon: true,
      desktopOnly: true,
    },
    {
      target: `.tour-edit-btn${suffix}`,
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa el <strong>lápiz </strong> para editar un trabajador: cambiar
          su información, los servicios que realiza, su horario, el intervalo
          entre citas o activar/desactivar su cuenta.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: `.tour-resend-btn${suffix}`,
      content: (
        <div style={{ textAlign: 'justify' }}>
          Este botón (el <strong>avión de papel ✈️</strong>) solo aparece en
          trabajadores que <strong>aún no han confirmado</strong> su cuenta.
          Púlsalo para <strong>reenviarles la invitación</strong> por correo si
          no la recibieron o la perdieron.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: '.tour-pagination',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Si tienes muchos trabajadores, usa la <strong>paginación</strong> para
          moverte entre páginas y ajustar cuántos ver a la vez.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
    },
    {
      target: 'body',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Al crear o editar un trabajador se abre un <strong>formulario</strong>{' '}
          donde asignas los servicios que realiza, defines su intervalo entre
          citas, activas o desactivas su cuenta y lo vinculas a la empresa. Una
          vez guardado, podrá recibir notificaciones y aparecerá disponible en
          las reservas.
        </div>
      ),
      placement: 'center',
      disableBeacon: true,
    },
  ];

  return allSteps
    .filter((s) => !(isMobile && s.desktopOnly))
    .map(({ desktopOnly, ...step }) => step);
};

export default getWorkersTourSteps;